
// Alert Icon - Exclamation mark in square
export const AlertIcon = ({ size = 16, color = "currentColor" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      width={size} 
      height={size} 
      fill={color}
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      // className={`fill-gray-500`}
    >
      <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth={0} />
      <path d="M12,7 L12,13" strokeWidth="2.5" stroke={color} strokeLinecap="round" className="stroke-white" />
      <line x1="12" y1="17" x2="12" y2="17" strokeWidth="2.5" className="stroke-white" />
    </svg>
  );
};

// Signal Level 1 (Low)
export const NoPriorityIcon = ({ size = 16, color = "currentColor" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      width={size} 
      height={size} 
      fill={color}
    >
      <rect x="10" y="12" width="4" height="2.5" rx="1" />
      <rect x="4" y="12" width="4" height="2.5" rx="1" />
      <rect x="16" y="12" width="4" height="2.5" rx="1" />
    </svg>
  );
};

// Signal Level 1 (Low)
export const SignalLow = ({ size = 16, color = "currentColor" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      width={size} 
      height={size} 
      fill={color}
    >
      <rect x="4" y="14" width="4" height="6" rx="1" />
      <rect x="10" y="9" width="4" height="11" rx="1" opacity="0.3" />
      <rect x="16" y="4" width="4" height="16" rx="1" opacity="0.3" />
    </svg>
  );
};

// Signal Level 2 (Medium)
export const SignalMedium = ({ size = 16, color = "currentColor" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      width={size} 
      height={size} 
      fill={color}
    >
      <rect x="4" y="14" width="4" height="6" rx="1" />
      <rect x="10" y="9" width="4" height="11" rx="1" />
      <rect x="16" y="4" width="4" height="16" rx="1" opacity="0.3" />
    </svg>
  );
};

// Signal Level 3 (Full)
export const SignalHigh = ({ size = 16, color = "currentColor" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      width={size} 
      height={size} 
      fill={color}
    >
      <rect x="4" y="14" width="4" height="6" rx="1" />
      <rect x="10" y="9" width="4" height="11" rx="1" />
      <rect x="16" y="4" width="4" height="16" rx="1" />
    </svg>
  );
};